<template>

  <site-form
    :title="title"
    :submit-button-text="submitButtonText"
    @submitSiteForm="onSubmit($event)"
  />

</template>

<script>

import router from '@/router'
import store from '@/store'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import SiteForm from './SiteForm.vue'

export default {
  components: {
    SiteForm,
  },
  data() {
    return {
      title: "Ajout d'un site",
      submitButtonText: 'Ajouter',
    }
  },
  setup() {
    const toast = useToast()

    const { clientId } = router.currentRoute.params

    const onSubmit = formValue => store.dispatch('site/addSite', { clientId, siteData: formValue })
      .then(() => {
        router.push({ name: 'sites-list', params: { id: clientId } })
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: "Erreur lors de l'ajout du site",
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })

    return {
      onSubmit,
    }
  },
}
</script>
